import React from "react";
import { Grid2, Stack, Typography } from "@mui/material";

type ProjectCardProps = {
  title: string;
  description: string;
  icon: React.ReactNode;
};

export const ProjectCard: React.FC<ProjectCardProps> = (props) => {
  const { title, icon, description } = props;

  return (
    <Grid2 size={{ md: 1, xs: 3 }}>
      <Stack
        width={1}
        height={1}
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        gap={1}
        border={2}
        borderColor="secondary.main"
        borderRadius={8}
        padding={4}
        sx={{
          alignItems: { md: "flex-start", xs: "center" },
          transition: "all 0.5s ease",

          "&:hover": {
            borderColor: "primary.main",
            transition: "all 0.5s ease",
          },
        }}
      >
        {icon}

        <Typography
          variant="h6"
          color="textSecondary"
          sx={{
            textAlign: { md: "start", xs: "center" },
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          color="textPrimary"
          sx={{
            textAlign: { md: "start", xs: "center" },
          }}
        >
          {description}
        </Typography>
      </Stack>
    </Grid2>
  );
};
